import { useState } from 'react';
import { FrontDesk } from './components/FrontDesk';
import { MailApp } from './apps/MailApp';
import { CalendarApp } from './apps/CalendarApp';
import { ContactsApp } from './apps/ContactsApp';
import { MessagesApp } from './apps/MessagesApp';
import { NotesApp } from './apps/NotesApp';
import { PhotosApp } from './apps/PhotosApp';
import { RemindersApp } from './apps/RemindersApp';
import { CallsApp } from './apps/CallsApp';
import { ICloudSync } from './components/iCloudSync';

export type AppId = 
  | 'mail' 
  | 'contacts' 
  | 'calendar' 
  | 'photos' 
  | 'icloud'
  | 'notes' 
  | 'reminders' 
  | 'messages' 
  | 'calls'
  | 'business'
  | null;

function App() {
  const [currentApp, setCurrentApp] = useState<AppId>(null);

  const handleAppLaunch = (appId: string) => {
    setCurrentApp(appId as AppId);
  };

  const handleBackToDesk = () => {
    setCurrentApp(null);
  };

  // Render current app
  const renderApp = () => {
    switch (currentApp) {
      case 'mail':
        return <MailApp onBack={handleBackToDesk} />;
      case 'calendar':
        return <CalendarApp onBack={handleBackToDesk} />;
      case 'contacts':
        return <ContactsApp onBack={handleBackToDesk} />;
      case 'icloud':
        return <ICloudSync onClose={handleBackToDesk} />;
      case 'messages':
        return <MessagesApp onBack={handleBackToDesk} />;
      case 'notes':
        return <NotesApp onBack={handleBackToDesk} />;
      case 'photos':
        return <PhotosApp onBack={handleBackToDesk} />;
      case 'reminders':
        return <RemindersApp onBack={handleBackToDesk} />;
      case 'calls':
        return <CallsApp onBack={handleBackToDesk} />;
      default:
        return <FrontDesk onAppLaunch={handleAppLaunch} />;
    }
  };

  return (
    <div className="min-h-screen bg-macos-gray-100 dark:bg-macos-gray-950">
      {renderApp()}
    </div>
  );
}

export default App;
